// pages/Auth/SamlAuth.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/Auth";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import paths from "../../constants/paths";
import { useOnboarding } from "../../contexts/onboarding";
import { useTeams } from "../../contexts/Teams";
import { useAlert } from "../../contexts/Alert";

const SamlAuth = () => {
  const navigate = useNavigate();
  const { verifyUserToken, updateAuthState } = useAuth();
  const { updateOnboardingState, next } = useOnboarding();
  const { updateInvitationState, next: teamNext } = useTeams();
  const { sendAlert } = useAlert();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") || localStorage.getItem('accessToken');
    const onboarding = params.get("onboarding");
    const isInvited = params.get("isInvited") ? Boolean(parseInt(params.get("isInvited"))) : false;
    const message = params.get("message");

    const processAuth = async () => {
      if (message) {
        sendAlert(message, 'success');
      }
      if (token) {
        // 1. Store token securely
        localStorage.setItem("accessToken", token);
        localStorage.setItem("isLoggedIn", true);

        updateAuthState({
          loginStatus: "LOADING",
          accessToken: token,
          isLoggedIn: true,
        });
        // 2. Verify token exists before proceeding
        const storedToken = localStorage.getItem("accessToken");
        if (!storedToken || storedToken !== token) {
          throw new Error("Token storage failed");
        }

        // 3. Fetch user with error handling
        try {
          await verifyUserToken();
          navigate(paths.home);
        } catch (error) {
          console.error("Token verification failed:", error);
          localStorage.removeItem("accessToken");
          localStorage.removeItem("isLoggedIn");
          updateAuthState({
            loginStatus: "ERROR",
            accessToken: null,
            isLoggedIn: false,
          });
          navigate(paths.login, {
            state: { error: "Session initialization failed" },
          });
        }
      } else if (onboarding) {
        const prefilledData = {
          email: params.get("email"),
          first_name: params.get("first_name"),
          last_name: params.get("last_name"),
          sso_onboarding: true,
        }
        if (isInvited) {
          updateInvitationState(prefilledData);
          updateOnboardingState(prefilledData);
        } else {
          updateOnboardingState(prefilledData);
        }
        !isInvited && next();
        const redirectionURL = isInvited && localStorage.getItem('invitationURL') ? localStorage.getItem('invitationURL') : paths.onboarding
        navigate(redirectionURL);
      } else {
        navigate(paths.login);
      }
    };

    processAuth();
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
      Processing SSO login...
    </Box>
  );
};

export default SamlAuth;
